import Home from "../components/Home";
import Shop from "../components/Shop";
import Login from "../components/Forms/Login";
//import Register from "../components/Forms/Register";
import RedeemCode from "../components/Forms/RedeemCode";
import Lobby from "../components/Room/Lobby";
import Join from "../components/Room/Join";
import MirrorJoin from "../components/Room/MirrorJoin";
import Checkout from "../components/Checkout";
import CheckoutReturn from "../components/CheckoutReturn";
import FormPage from "../components/Forms/FormPage"
import PolicyPage from "../components/policy/PolicyPage"
import Help from "../components/Help";

import ShopSingle from "components/ShopSingle";
import Play from "components/Room/Play";
/*import PlayRoku from "components/Room/PlayRoku";*/
import Roku from "components/Roku/Roku";
import ShopGamePack from "components/ShopGamePack";
import CookiePolicy from "components/policy/CookiePolicy";
import DataProtection from "components/policy/DataProtection";
import PrivacyPolicy from "components/policy/PrivacyPolicy";
import TermsConditions from "components/policy/TermsConditions";

import ForgotPassword from "../components/Forms/ForgotPassword";
import ResetPassword from "../components/Forms/ResetPassword";
import ForwardingURL from "../components/ForwardingURL";
//import Application from "../components/policy/Application";
//import JuneGiveaway from "../components/policy/JuneGiveaway";
//import FriYayGiveaway from "../components/policy/FriYayGiveaway";
import ShopAddon from "../components/ShopAddon";
import ResetPIN from "../components/Forms/ResetPIN";
import Profile from "../components/Profile/Profile";
import AdminImpersonate from "../components/AdminImpersonate";
import ArticlesHub from "../components/Articles/ArticlesHub";
import ArticlesCategory from "../components/Articles/ArticlesCategory";
import ArticleDetail from "../components/Articles/ArticleDetail";

import { CONNECT_ENABLED } from "./FeatureFlags";



const AppRoutes = [
    {
        index: true,
        path: "/",
        element: <Home />
    },
    {
        index: 2,
        path: "/login",
        element: <FormPage is="login"><Login /></FormPage>
    },
    //{
    //    index: 3,
    //    path: "/register",
    //    element: <FormPage><Register /></FormPage>
    //},
    {
        index: 4,
        path: "/redeem-code",
        element: <FormPage><RedeemCode /></FormPage>,
        private: true,
    },
    {
        index: 5,
        path: "/lobby",
        element: <Lobby />,
        private: true,
    },
    {
        index: 6,
        path: "/join",
        element: <FormPage><Join /></FormPage>,
    },
    ...(CONNECT_ENABLED ? [
        {
            path: "/connect",
            element: <FormPage><MirrorJoin /></FormPage>,
        },
        {
            path: "/mirror",
            element: <FormPage><MirrorJoin /></FormPage>,
        },
    ] : []),
    {
        index: 7,
        path: "/checkout",
        element: <Checkout />,
    },
    {
        index: 8,
        path: "/checkout-return",
        element: <FormPage><CheckoutReturn /></FormPage>,
    },
    // Shop And Store Pages
    {
        index: 9,
        path: "/shop",
        element: <Shop />,
    },
    {
        index: 18,
        path: "/play",
        element: <Play />
    },
    {
        path: "/roku",
        element: <Roku />
    },
    {
        path: "/firetv",
        element: <Roku />
    },
    {
        index: 19,
        path: "/cookie-policy",
        element: <PolicyPage><CookiePolicy /></PolicyPage>
    },
    {
        index: 20,
        path: "/privacy-policy",
        element: <PolicyPage><PrivacyPolicy /></PolicyPage>
    },
    {
        index: 21,
        path: "/data-protection",
        element: <PolicyPage><DataProtection /></PolicyPage>
    },
    {
        index: 22,
        path: "/terms",
        element: <PolicyPage><TermsConditions/></PolicyPage>
    },
    //{
    //    path: "/jubilant-june",
    //    element: <PolicyPage><JuneGiveaway /></PolicyPage>
    //},
    //{
    //    path: "/fri-yay-giveaway",
    //    element: <PolicyPage><FriYayGiveaway /></PolicyPage>
    //},
    {
        index: 23,
        path: "/help",
        element: <Help />
    },
    {
        index: 24,
        path: "/forgot-password",
        element: <FormPage><ForgotPassword /></FormPage>
    },
    {
        index: 25,
        path: "/reset-password",
        element: <FormPage><ResetPassword /></FormPage>
    },
    {
        path: "/reset-pin",
        element: <FormPage><ResetPIN /></FormPage>,
        private: true,
    },
    {
        element: <Profile />,
        path: "/my-account",
        private: true,
    },
    {
        path: "/my-account/:section",
        element: <Profile />,
        private: true,
    },
    {
        path: "/qr2023",
        element: <ForwardingURL />
    },
    {
        path: "/admin-impersonate",
        element: <AdminImpersonate />
    },
    // Articles / Editorial
    {
        index: 26,
        path: "/articles",
        element: <ArticlesHub />,
    },
    {
        index: 27,
        path: "/articles/category/:categorySlug",
        element: <ArticlesCategory />,
    },
    {
        index: 28,
        path: "/articles/:slug",
        element: <ArticleDetail />,
    },
    // Dynamic shop routes - these use slug-based lookup from the URL
    // More specific routes must come before more general ones
    {
        path: "/shop/addons/:slug",
        element: <ShopAddon />,
    },
    {
        path: "/shop/game-pack-:packNum",
        element: <ShopGamePack />,
    },
    // Catch-all for individual game pages - must be last
    {
        path: "/shop/:slug",
        element: <ShopSingle />,
    },
];

export default AppRoutes;
